module.exports = __webpack_public_path__ + "img/topzlyd_bg.1ba3ebeb.png";